// @flow
import {graphql} from 'react-relay'

import createMutationPromise, {type MutationInput} from '../createMutationPromise'
import type {Input, Response} from './types'

const mutation = graphql`
  mutation DeleteProposalMutation(
    $input: DeleteProposalInput!
  ) {
    deleteProposal(input: $input) {
      deletedProposalId
      tension {
        id
        databaseId
        isAutogenerated
        processed

        proposal {
          id
        }
      }
    }
  }
`

const DeleteProposalMutation = (
  input: MutationInput<Input>,
  noDeleteConfig: boolean = false,
): Promise<Response> => {
  const variables = {
    input,
  }

  const configs = noDeleteConfig ? [] : [{
    type: 'NODE_DELETE',
    deletedIDFieldName: 'deletedProposalId',
  }]

  return createMutationPromise({
    mutation,
    variables,
    configs,
  })
}

export default DeleteProposalMutation
export type {
  Response,
  Input,
}
